import { Text, View, StyleSheet, Font } from '@react-pdf/renderer';
import moment from 'moment';
import { Fragment, useContext } from 'react';
import { GlobalContext } from '../../context/Provider';
import { dataType } from '../../pages/order/orderInterface';
import { LanguageKeys } from '../../context/providerInterface';


Font.register({
    family: 'bold',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
    fontWeight: 'bold'
});

Font.register({
    family: 'italic',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-mediumitalic-webfont.ttf",
});

Font.register({
    family: 'italic-regular',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf",
});

Font.register({
    family: 'medium',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
});

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    w_20: {
        width: '20%',
    },
    w_30: {
        width: '30%',
    },
});

const InvoiceDetail = ({ dataHolder }: dataType) => {

    const { authState, language_data } = useContext(GlobalContext);

    // Translation helper
    const t = (key: keyof LanguageKeys, fallback: string) =>
        language_data?.[authState?.lang as any]?.[key] || fallback;

    return (
        <Fragment>

            <View style={styles.container}>

                {/* Order Detail */}
                <View style={styles.w_30}>

                    <Text style={{ fontFamily: 'bold', marginBottom: 5 }}>
                        {t('common_order', 'Order')} {t('common_id', 'ID')}:
                        {dataHolder?.order_id || t('common_not_available', 'N/A')}
                    </Text>

                    <View style={[styles.container, { marginBottom: 5 }]}>
                        <Text style={{ fontFamily: 'bold', marginRight: 3 }}>
                            {t('common_order', 'Order')} {t('common_date', 'Date')}:
                        </Text>
                        <Text>
                            {dataHolder?.created_at
                                ? moment(dataHolder.created_at).format('DD-MM-YYYY')
                                : t('common_not_available', 'N/A')}
                        </Text>
                    </View>

                    <View style={[styles.container, { marginBottom: 5 }]}>
                        <Text style={{ fontFamily: 'bold', marginRight: 3 }}>
                            {t('common_invoice', 'Invoice')} {t('common_date', 'Date')}:
                        </Text>
                        <Text>
                            {dataHolder?.created_at
                                ? moment(dataHolder.created_at).format('DD-MM-YYYY')
                                : t('common_not_available', 'N/A')}
                        </Text>
                    </View>

                </View>

                {/* Bill To */}
                <View style={styles.w_30}>

                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_bill', 'Bill')} {t('common_to', 'To')}
                    </Text>

                    <Text style={{ fontFamily: 'bold', marginBottom: 4 }}>
                        {dataHolder?.user_id?.name || t('common_not_available', 'N/A')}
                    </Text>

                    <Text style={{ width: '80%' }}>
                        {dataHolder?.address_id?.full_address || t('common_not_available', 'N/A')}
                    </Text>

                    <Text>
                        {dataHolder?.user_id?.phone_no
                            ? `Phone: ${dataHolder.user_id.phone_no}`
                            : t('common_not_available', 'N/A')}
                    </Text>

                </View>

                {/* Ship To */}
                <View style={styles.w_20}>

                    <Text style={{ fontFamily: 'bold' }}>
                        {t('common_ship', 'Ship')} {t('common_to', 'To')}
                    </Text>

                    <Text style={{ fontFamily: 'bold', marginBottom: 4 }}>
                        {dataHolder?.user_id?.name || t('common_not_available', 'N/A')}
                    </Text>

                    <Text>
                        {dataHolder?.address_id?.full_address || t('common_not_available', 'N/A')}
                    </Text>

                    <Text>
                        {dataHolder?.user_id?.phone_no
                            ? `Phone: ${dataHolder.user_id.phone_no}`
                            : t('common_not_available', 'N/A')}
                    </Text>

                </View>

                {/* Warranty Text */}
                <View style={styles.w_20}>

                    <Text style={{ textAlign: 'right', fontFamily: 'italic-regular', marginBottom: 13 }} />

                    <Text style={{ textAlign: 'right', fontFamily: 'italic-regular' }}>
                        *{t('common_keep', 'Keep')} {t('common_this', 'this')} {t('common_invoice', 'invoice')} {t('common_and', 'and')}
                    </Text>

                    <Text style={{ textAlign: 'right', fontFamily: 'italic-regular' }}>
                        {t('common_manufacturer', 'manufacturer')} {t('common_box', 'box')} {t('common_for', 'for')}
                    </Text>

                    <Text style={{ textAlign: 'right', fontFamily: 'italic-regular' }}>
                        {t('common_warranty', 'warranty')} {t('common_purpose', 'purpose')}.
                    </Text>

                </View>

            </View>

            {/* Total Items */}
            <View style={styles.container}>
                <Text style={{ fontFamily: 'medium', marginTop: 20 }}>
                    {t('common_total', 'Total')} {t('common_item', 'Item')}: {dataHolder?.quantity || 0}
                </Text>
            </View>

            <View style={{ borderBottom: '1px solid #000', margin: '0 0 10px' }} />

        </Fragment>
    );
};

export default InvoiceDetail;